exports = module.exports = require("../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toggle-switch{display:inline-block;cursor:pointer;border-radius:4px;border:1px solid;border-color:#ccc;position:relative;text-align:left;overflow:hidden;line-height:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;min-width:100px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.toggle-switch .knob{color:#333;background:#fff;border:3px}.toggle-switch .switch-left{color:#fff;background:#428bca}.toggle-switch .switch-right{color:#000;background:#eee}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/angular-toggle-switch/angular-toggle-switch-bootstrap.css
// module id = 281
// module chunks = 2